module.exports = __webpack_public_path__ + "img/ios_model_area_300.fd46105d.jpg";